import { EAuthRole, useAuth } from '@qapline/api';

export const useIsAdmin = () => {
    const { user } = useAuth();
    return user?.role === EAuthRole.Admin;
};
